import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ConfigContext } from 'context/config';
import useFeature from 'hooks/useFeature';
import FEATURES from 'constants/features';
import Typography from '@mui/material/Typography';
import AllSettingsIcon from '@mui/icons-material/WidgetsOutlined';
import { SomeFeatures } from 'components/WithFeature';
import SettingsItems from '../settings-items';

const NavItem = ({ to, exact, children, Icon }) => (
  <ListItem
    button
    component={NavLink}
    to={to}
    exact={exact}
    activeClassName="Mui-selected"
    sx={{
      'minHeight': 48,
      'borderRadius': 1,
      '&.Mui-selected': {
        'backgroundColor': 'background.paper',
        'boxShadow':
          '0px 2px 16px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(24, 24, 43, 0.08)',
        '& .MuiListItemIcon-root': {
          color: 'primary.main',
        },
      },
    }}
  >
    <ListItemIcon sx={{ mr: 3, minWidth: 0 }}>
      {React.createElement(Icon, { color: 'text.secondary' })}
    </ListItemIcon>
    <ListItemText
      primary={children}
      primaryTypographyProps={{
        fontWeight: '500',
        sx: {
          color: 'inherit',
        },
      }}
    />
  </ListItem>
);

export default (props = {}) => {
  const config = useContext(ConfigContext);
  const [t] = useTranslation('navigation');
  const user = useSelector((s) => s.user.user);
  const hasDevFeature = useFeature(FEATURES.DEVELOPER_ACCESS);
  const isAdmin = user.users_record_is_admin === '1';

  return (
    <Box width={240} flexShrink={0}>
      <List {...props}>
        <NavItem exact to="/settings" Icon={AllSettingsIcon}>
          {t('all-settings-link', 'All Settings')}
        </NavItem>
        <Box mb={3} />
        {SettingsItems.map((item, i) => (
          <React.Fragment key={i}>
            <Typography paragraph variant="subtitle1" fontWeight={600}>
              {t(item.label)}
            </Typography>
            {item.items.map((subItem, idx) => {
              return (
                <SomeFeatures features={subItem.features} key={idx}>
                  <NavItem
                    to={subItem.to}
                    Icon={subItem.icon2}
                    exact={subItem.exact}
                  >
                    {subItem.label}
                  </NavItem>
                </SomeFeatures>
              );
            })}
            <Box mb={3} />
          </React.Fragment>
        ))}
        {/*<Typography paragraph variant="subtitle1" fontWeight={600}>*/}
        {/*  Account*/}
        {/*</Typography>*/}
        {/*<NavItem exact to="/settings/users" Icon={<UsersIcon />}>*/}
        {/*  {t('account-users-link', 'Users')}*/}
        {/*</NavItem>*/}
        {/*<SomeFeatures*/}
        {/*  features={[*/}
        {/*    FEATURES.PCO,*/}
        {/*    FEATURES.MC,*/}
        {/*    FEATURES.CCB,*/}
        {/*    FEATURES.DIGIGIV,*/}
        {/*    FEATURES.ZAPIER,*/}
        {/*    FEATURES.ROCK,*/}
        {/*  ]}*/}
        {/*>*/}
        {/*  <NavItem to="/settings/integrations" Icon={<IntegrationsIcon />}>*/}
        {/*    {t('integrations-link', 'Integrations')}*/}
        {/*  </NavItem>*/}
        {/*</SomeFeatures>*/}
        {/*<Access module={MODULES.BILLING}>*/}
        {/*  <NavItem to="/settings/payment" Icon={<PaymentIcon />}>*/}
        {/*    {t('payment-link', 'Payment')}*/}
        {/*  </NavItem>*/}
        {/*</Access>*/}
        {/*<Access module={MODULES.BILLING}>*/}
        {/*  <NavItem to="/settings/subscription" Icon={<SubscriptionIcon />}>*/}
        {/*    {t('subscription-link', 'Subscriptions & Invoices')}*/}
        {/*  </NavItem>*/}
        {/*</Access>*/}
        {/*{isAdmin && (*/}
        {/*  <NavItem to="/settings/sender-profile" Icon={<SenderProfileIcon />}>*/}
        {/*    {t('sender-profile-link', 'Sender Profile')}*/}
        {/*  </NavItem>*/}
        {/*)}*/}
        {/*{config.BRAND === 'TIC' && (*/}
        {/*  <NavItem to="/settings/referrals" Icon={<ReferralIcon />}>*/}
        {/*    {t('referral-link', 'Refer a Friend')}*/}
        {/*  </NavItem>*/}
        {/*)}*/}
        {/*<NavItem to="/settings/variables" Icon={<VariableIcon />}>*/}
        {/*  {t('variables-link', 'Message Variables')}*/}
        {/*</NavItem>*/}
        {/*<NavItem to="/settings/templates" Icon={<VariableIcon />}>*/}
        {/*  {t('templates-link', 'Message Templates')}*/}
        {/*</NavItem>*/}
        {/*{isAdmin && (*/}
        {/*  <NavItem to="/settings/custom-fields" Icon={<ContactFieldIcon />}>*/}
        {/*    {t('custom-fields-link', 'Contact Custom Fields')}*/}
        {/*  </NavItem>*/}
        {/*)}*/}
        {/*<WithFeature feature={FEATURES.PEOPLE_PREMIUM}>*/}
        {/*  <NavItem to="/settings/contact-layout" Icon={<PeopleLayoutIcon />}>*/}
        {/*    {t('contact-layout-link', 'Contact Details Layout')}*/}
        {/*  </NavItem>*/}
        {/*</WithFeature>*/}
        {/*{hasDevFeature && (*/}
        {/*  <NavItem Icon={<AppsIcon />} to="/settings/developer">*/}
        {/*    {t('developer-link', 'Developer')}*/}
        {/*  </NavItem>*/}
        {/*)}*/}
      </List>
    </Box>
  );
};
